// extracted by mini-css-extract-plugin
module.exports = {"detail_content":"Notice_style_detail_content__wQLk8","title":"Notice_style_title__ittQh","content":"Notice_style_content__UAUGW"};